<template>
  <div class="zt-accordion w-full">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ztAccordion',
  inheritAttrs: false,
}
</script>


